module.exports = __webpack_public_path__ + "static/media/thanks-for-your-request.5248c141.svg";